import Service from '../Service'
import { LandingTysonInstance } from './InstanceTyson'

export class SendWhatsappService extends Service {
  constructor() {
    super()
    this._appName = 'prospecting-agent'
    this._phone = ''
    this._agent = 'prospecting'
    this._idSolicitud = ''
    this._empresa = ''
  }

  setAppName(appName) {
    this._appName = `${appName}`
  }

  setPhone(phone) {
    this._phone = `${phone}`
  }

  setAgent(agent) {
    this._agent = `${agent}`
  }

  setIdSolicitud(idSolicitud) {
    this._idSolicitud = `${idSolicitud}`
  }

  setEmpresa(empresa) {
    this._empresa = `${empresa}`
  }

  get data() {
    return {
      appName: `${this._appName}`,
      data: {
        phone: `${this._phone}`,
        agent: `${this._agent}`,
        idSolicitud: `${this._idSolicitud}`,
        empresa: `${this._empresa}`
      }
    }
  }

  send() {
    return this._requestWrapper(LandingTysonInstance({
      method: 'POST',
      url: '/comunication/send-whatsapp',
      data: this.data
    }))
  }
}
